import "./App.css";
import AppLayout from "./layout/AppLayout";
import { /*Route, Routes,*/ BrowserRouter } from "react-router-dom";
// import { HomePage } from "./pages/home-page";
// import { ContactPage } from "./pages/contactForm";
import ReactGA from "react-ga4";
import { AnimatedRoutes } from "./AnimatedRoutes";

const TRACKING_ID = "G-D7Y71RKCQL"; // MY_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function App() {
  return (
    <BrowserRouter>
      <AppLayout>
        <AnimatedRoutes />
      </AppLayout>
    </BrowserRouter>
  );
}

export default App;
